import React from 'react';
import { useAuth } from '../contexts/AuthContext';
export function Header() {
  const {
    user
  } = useAuth();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const handleDashboardClick = () => {
    window.location.href = '/dashboard';
  };
  return <header className="sticky top-0 z-50 bg-white border-b border-gray-200" data-id="element-196">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="flex justify-between items-center h-16" data-id="element-198">
          <button onClick={scrollToTop} className="text-xl font-bold text-gray-900 hover:text-gray-700 transition-colors" data-id="element-199">
            Cefapay Card
          </button>

          <div className="flex items-center gap-3" data-id="element-200">
            {/* Dashboard Button (only if logged in) */}
            {user && <button onClick={handleDashboardClick} className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium text-sm" data-id="element-201">
                Dashboard
              </button>}
          </div>
        </div>
      </nav>
    </header>;
}